export default __webpack_public_path__ + "static/4-094cc764c290b1e1ad3297870ee310ca.jpg";